import { links, person } from "../data/site";

export default function Footer() {
  return (
    <footer className="footer">
      <div className="shell footer__inner">
        <div>
          <p className="footer__name">{person.name}</p>
          <p className="label">
            {person.role}, {person.location}
          </p>
        </div>

        <ul className="footer__links">
          {[
            ["GitHub", links.github],
            ["LinkedIn", links.linkedin],
            ["Instagram", links.instagram],
            ["WhatsApp", links.whatsapp],
          ].map(([label, href]) => (
            <li key={label}>
              <a className="link" href={href} target="_blank" rel="noreferrer">
                {label}
              </a>
            </li>
          ))}
        </ul>

        <p className="label footer__meta">
          Built by hand, {new Date().getFullYear()}
        </p>
      </div>
    </footer>
  );
}
